import { useIntl } from "react-intl";

// Mui Components
import { Box, Button, Grid, Typography } from "@mui/material";

// Components
import NavButton from "components/HeaderNavigation/NavButton";

// Hooks
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

// Enums
import { urlPaths } from "enums/urlPaths";

// Styles
import refinementHeaderStyles from "./RefinementHeader.styles";

type RefinementHeaderProps = {
    shouldDisableAnalyse: boolean;
    handleShowCharts: () => void;
    handleUpdateRefinement: () => Promise<void>;
};

const RefinementHeader = ({
    shouldDisableAnalyse,
    handleShowCharts,
    handleUpdateRefinement,
}: RefinementHeaderProps): JSX.Element => {
    const classes = refinementHeaderStyles();
    const intl = useIntl();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { companyId } = useParams();
    const projectId = searchParams.get("projectId");
    const insightId = searchParams.get("insightId");
    const briefId = searchParams.get("briefId");
    const searchAiId = searchParams.get("searchAiId");

    const goToSearchCandidates = async () => {
        navigate(
            `${urlPaths.TalentPeople}/${companyId}?projectId=${projectId}&insightId=${insightId}&briefId=${briefId}&searchAiId=${searchAiId}`
        );
    };

    const goToSetTeam = async () => {
        await handleUpdateRefinement();
        navigate(
            `${urlPaths.Team}/${companyId}?projectId=${projectId}&insightId=${insightId}&briefId=${briefId}&searchAiId=${searchAiId}`
        );
    };

    return (
        <Grid container className={classes.refinementHeader}>
            <Typography className={classes.refinementHeaderTitle}>
                {intl.formatMessage({ id: "refinement.title" })}
            </Typography>
            <Box display="flex">
                <Button variant="contained" onClick={handleShowCharts} disabled={shouldDisableAnalyse}>
                    {intl.formatMessage({ id: "refinement.analyse" })}
                </Button>
            </Box>
            <Box>
                <NavButton isBackButton translationId="refinement.searchCandidates" onClick={goToSearchCandidates} />
                <NavButton translationId="button.editTeam" onClick={goToSetTeam} />
            </Box>
        </Grid>
    );
};

export default RefinementHeader;
